<template>
  <div class="testPage">
    <realTimeBusBox></realTimeBusBox>
    <pointMallBox></pointMallBox>
    <equityCenterBox></equityCenterBox>
    <vipBox></vipBox>
    <metroBox></metroBox>
    <MaaSBox></MaaSBox>
    <parkCarBox></parkCarBox>
    <AirplaneBox></AirplaneBox>
    <trainBox></trainBox>
    <coachBox></coachBox>
    <qrCodeBox></qrCodeBox>
    <takeTaxiBox></takeTaxiBox>
  </div>
</template>

<script>
import realTimeBusBox from "@/components/realTimeBusBox/realTimeBusBox";
import pointMallBox from "@/components/pointMallBox/pointMallBox";
import equityCenterBox from "@/components/equityCenterBox/equityCenterBox";
import vipBox from "@/components/vipBox/vipBox";
import metroBox from "@/components/metroBox/metroBox";
import MaaSBox from "@/components/MaaSBox/MaaSBox";
import parkCarBox from "@/components/parkCarBox/parkCarBox";
import trainBox from "@/components/trainBox/trainBox";
import coachBox from "@/components/coachBox/coachBox";
import qrCodeBox from "@/components/qrCodeBox/qrCodeBox";
import takeTaxiBox from "@/components/takeTaxiBox/takeTaxiBox";
import AirplaneBox from "@/components/airplaneBox/airplaneBox";
export default {
  components: {
    vipBox,
    metroBox,
    MaaSBox,
    parkCarBox,
    qrCodeBox,
    takeTaxiBox,
    coachBox,
    trainBox,
    AirplaneBox,
    equityCenterBox,
    pointMallBox,
    realTimeBusBox,
  },
};
</script>

<style lang="scss" scoped>
.testPage {
  padding: 10px;
}
</style>
